/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GoogleProtobufAnyFromJSON, GoogleProtobufAnyToJSON, } from './';
export function StreemApiErrorResponseErrorFromJSON(json) {
    return StreemApiErrorResponseErrorFromJSONTyped(json, false);
}
export function StreemApiErrorResponseErrorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'code': !exists(json, 'code') ? undefined : json['code'],
        'message': !exists(json, 'message') ? undefined : json['message'],
        'meta': !exists(json, 'meta') ? undefined : (json['meta'].map(GoogleProtobufAnyFromJSON)),
    };
}
export function StreemApiErrorResponseErrorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'code': value.code,
        'message': value.message,
        'meta': value.meta === undefined ? undefined : (value.meta.map(GoogleProtobufAnyToJSON)),
    };
}
//# sourceMappingURL=StreemApiErrorResponseError.js.map